export function isBlankValue(value: string | null): boolean {
  return value == null || value === ""
}
